import { Employee } from './employee';

export class EmployeePosition {
    positionId: string;
    positionName: string;
    valid: string;
    employee: Employee[];
}